import { render, staticRenderFns } from "./reload.vue?vue&type=template&id=68d792b8&"
import script from "./reload.vue?vue&type=script&lang=js&"
export * from "./reload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/reload.vue
// module id = 1522
// module chunks = 0